import { Star, Facebook } from "lucide-react";

export default function ReviewCard({ review }) {
  return (
    <article
      data-testid={`review-card-${review.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
      className="relative flex h-full flex-col border border-white/10 bg-navy-950 p-8 transition-colors duration-300 hover:border-gold/40"
    >
      <span className="pointer-events-none absolute -top-2 right-6 font-display text-8xl font-extrabold leading-none text-gold/15 select-none" aria-hidden="true">
        &rdquo;
      </span>
      <div className="flex gap-1 text-gold" aria-label="5 out of 5 stars">
        {[...Array(5)].map((_, s) => (
          <Star key={s} className="h-4 w-4" fill="currentColor" />
        ))}
      </div>
      <div className="mt-5 flex-1 space-y-4">
        {review.text.split("\n\n").map((p, i) => (
          <p key={i} className="text-sm leading-relaxed text-slate-300">
            {p}
          </p>
        ))}
      </div>
      <footer className="mt-7 flex items-center gap-4 border-t border-white/10 pt-6">
        <img
          src={review.photo}
          alt={`${review.name} profile photo`}
          className="h-12 w-12 rounded-full object-cover ring-2 ring-gold/50"
          loading="lazy"
        />
        <div className="flex-1">
          <p className="font-display text-base font-bold uppercase tracking-wide text-white">{review.name}</p>
          <p className="text-[11px] uppercase tracking-[0.2em] text-slate-500">{review.date}</p>
        </div>
        <a
          href={review.postUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`review-source-${review.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
          className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-gold"
          aria-label={`Read ${review.name}'s review on Facebook`}
        >
          <Facebook className="h-3.5 w-3.5 text-gold/70" /> Facebook
        </a>
      </footer>
    </article>
  );
}
